type StatusMap = {
  [key in "ENABLED" | "DISABLED" | "NOT_VERIFIED" | "DELETED"]: string
}

export const userStatusMap: StatusMap = {
  ENABLED: "Abilitato",
  DISABLED: "Disabilitato",
  DELETED: "Eliminato",
  NOT_VERIFIED: "Non verificato"
}